import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberForm from '../../../components/forms/MemberForm';
import { MemberClient, MemberDTO } from '../../../services/apiClient';
import { useNavigate, useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import Card from '../../../components/common/Card';
import axiosInstance from "../../../services/axiosInstance";

const MemberEdit: React.FC = () => {
  const [entityData, setEntityData] = useState<MemberDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const apiClient = new MemberClient(API_BASE_URL, axiosInstance);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Members', href: '/admin/members' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await apiClient.getMemberById(id!);
        setEntityData(response.data || null);
      } catch (error) {
        console.error('Error fetching Member data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    setIsSubmitting(true);
    try {
      await apiClient.updateMember(id!, data);
      navigate('/admin/members');
    } catch (error) {
      console.error('Error updating Member:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/members"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
      <Card title="Edit Member">
        {entityData ? (
          <MemberForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/members')}
          />
        ) : (
          <p>Loading...</p>
        )}
      </Card>
    </AdminLayout>
  );
};

export default MemberEdit;
